<template>
  <div>
    <div class="form_box">
      <el-table empty-text="暂无数据" :data="tableData" border>
        <el-table-column label="报案用户" min-width="50">
          <template slot-scope="scope">
            {{scope.row.obj.reportUser}}
          </template>
        </el-table-column>
        <el-table-column label="用户手机号" min-width="50">
          <template slot-scope="scope">
            {{scope.row.obj.reporterContact}}
          </template>
        </el-table-column>
        <el-table-column label="报案时间" min-width="50">
          <template slot-scope="scope">
            {{setTime(scope.row.obj.reportTs)}}
          </template>
        </el-table-column>
        <el-table-column label="出险人" min-width="50">
          <template slot-scope="scope">
            {{scope.row.victimList[0].obj.victimName}}
          </template>
        </el-table-column>
        <el-table-column prop="place" label="出险地" min-width="50">
          <template slot-scope="scope">
            {{setTxt(scope.row.generalLocation.addr)}}
          </template>
        </el-table-column>
       <el-table-column  label="出险人保障" min-width="50">
         <template slot-scope="scope">
           {{statusObj[scope.row.obj.caseInsured]}}
         </template>
       </el-table-column>
        <el-table-column prop="source" label="案件来源" min-width="50">
          <template slot-scope="scope">
            {{scope.row.obj.caseSrc}}
          </template>
        </el-table-column>
        <el-table-column prop="op" label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button type='text' @click='topathDetail(scope.row.obj.id,scope.row.obj.initialCaseId)'>案件详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 弹窗 -->
    <el-dialog title="确认完成案件" center :visible.sync="dialogFormVisible" width="800px">
      <div class="popBox">
        救援费用:
        <ul>
          <li>
            <span>救援费用</span>
            <input type="text" v-model="rescueFee">
            <span>RMB</span>
          </li>
          <li>
            <span>医疗费用</span>
            <input type="text" v-model="medicFee">
            <span>RMB</span>
          </li>
          <li>
            <span>其他费用</span>
            <input type="text" v-model="otherFee">
            <span>RMB</span>
          </li>
        </ul>
      </div>
    	<div slot="footer" class="dialog-footer">
    		<el-button @click="dialogFormVisible = false">取 消</el-button>
    		<el-button type="primary" @click="sureFun()">确 定</el-button>
    	</div>
    </el-dialog>
  </div>
</template>

<script>
  import { finishXingshiGong } from '@/views/axios/api.js'
  import constants from '@/util/constants.js';
  export default {
    data() {
      return {
        tableData: [],
        token: JSON.parse(window.localStorage.getItem("data")).data,
        userType:JSON.parse(window.localStorage.getItem("insti")).type,
        dialogFormVisible:false,
        totalFee:'',
        rescueFee:'',
        medicFee:'',
        otherFee:0,
        caseId:'',
        statusObj:['在保','无保','在保','旅责险']
      };
    },
    methods: {
     setTxt(str, status) {
      	return constants.setTxt(str, status)
      },
      setTime(str) {
        return constants.time(str)
      },
      getData() {
        var data = {
          token: this.token,
          typeId: 600
        }
        finishXingshiGong(data,'status=110')
          .then(res => {
            console.log(res);
            this.tableData=res.data.obj
          })
          .catch(err => {
            console.log(data);
          })
      },
      topathDetail(id1,glId){
        let path='',id=''
        console.log(this.userType);
        if(this.userType == 1){
          path='/cmd_center/caseDetails';
          id=glId
        }else{
          path='/branch/starindex/starsdetail';
          id=id1
        }
        this.$router.push({
          path,
          query:{caseid:id}
        })
      },
    },
    mounted() {
      this.getData()
    }
  };
</script>

<style scoped>
.popBox li{margin-bottom: 10px;}
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/star/starcompleted.vue